import { Injectable } from '@angular/core';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class TokenStorageService {

  accessTokenStorageKey = "access_token";

  expiresInStorageKey = "expires_in";

  storeTimeStorageKey = "expires_origin";

  constructor() { }

  storeToken(token) {
    localStorage.setItem(this.accessTokenStorageKey, token);
  }

  loadToken() {
    return localStorage.getItem(this.accessTokenStorageKey);
  }

  clearToken() {
    return localStorage.removeItem(this.accessTokenStorageKey);
  }

  storeExpiresIn(expires_in) {
    return localStorage.setItem(this.expiresInStorageKey, expires_in);
  }

  loadExpiresIn() {
    return localStorage.getItem(this.expiresInStorageKey);
  }

  clearExpiresIn() {
    localStorage.removeItem(this.expiresInStorageKey);
  }

  loadStoreTime() {
    return localStorage.getItem(this.storeTimeStorageKey);
  }

  storeStoreTime(time) {
    localStorage.setItem(this.storeTimeStorageKey, time);
  }

  clearStoreTime() {
    localStorage.removeItem(this.storeTimeStorageKey);
  }
}
